const { data } = require('jquery');
require('./bootstrap');

$(function(){
    AOS.init()

    gfn.globalEvent()
})
